import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ai-rec"
}
const _hoisted_2 = {
  key: 0,
  class: "ai-rec-hint"
}
const _hoisted_3 = ["title"]
const _hoisted_4 = {
  key: 2,
  class: "ai-rec-hint"
}
const _hoisted_5 = {
  key: 1,
  class: "ai-rec-pill"
}
const _hoisted_6 = {
  key: 0,
  class: "ai-rec-note",
  title: "Microphone unavailable — your voice may not be included"
}
const _hoisted_7 = ["title"]
const _hoisted_8 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}
const _hoisted_9 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}
const _hoisted_10 = {
  key: 2,
  class: "ai-rec-float-pref"
}
const _hoisted_11 = {
  key: 3,
  class: "ai-rec-guard",
  role: "alertdialog",
  "aria-labelledby": "ai-rec-guard-title",
  "aria-describedby": "ai-rec-guard-text"
}
const _hoisted_12 = { class: "ai-rec-guard-actions" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  key: 4,
  class: "ai-rec-guide"
}
const _hoisted_16 = {
  key: 7,
  class: "ai-rec-audio-status"
}
const _hoisted_17 = ["aria-valuenow"]
const _hoisted_18 = { key: 1 }
const _hoisted_19 = {
  key: 1,
  class: "ai-rec-hint"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AiShareGuide = _resolveComponent("AiShareGuide")!
  const _component_AiShareCoach = _resolveComponent("AiShareCoach")!
  const _component_AiFloatingRecorder = _resolveComponent("AiFloatingRecorder")!

  return (_ctx.supported)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!_ctx.state && !_ctx.hideStart)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", {
                class: "ai-btn ai-btn-ghost",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.start()))
              }, [
                _cache[11] || (_cache[11] = _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "14",
                  height: "14",
                  viewBox: "0 0 24 24",
                  fill: "currentColor"
                }, [
                  _createElementVNode("path", { d: "M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm0-2a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm10-3H2a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1h6v2H6v2h12v-2h-2v-2h6a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zm-1 13H3V6h18v11z" })
                ], -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.audioOnly ? 'Record meeting' : 'Record your screen'), 1)
              ]),
              (_ctx.audioOnly && !_ctx.state)
                ? (_openBlock(), _createElementBlock("label", _hoisted_2, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.shareAudio) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.shareAudio]
                    ]),
                    _cache[12] || (_cache[12] = _createTextVNode(" Include audio from a shared tab or screen", -1))
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.audioOnly)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(["ai-rec-mic-toggle", { 'ai-rec-mic-off': !_ctx.micEnabled }]),
                    title: _ctx.micEnabled ? 'Narration mic is on — click to record without it' : 'Narration mic is off — click to record with it',
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.micEnabled = !_ctx.micEnabled))
                  }, [
                    _cache[13] || (_cache[13] = _createElementVNode("svg", {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "12",
                      height: "12",
                      viewBox: "0 0 24 24",
                      fill: "currentColor"
                    }, [
                      _createElementVNode("path", { d: "M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.91-3c-.49 0-.9.36-.98.85C16.52 14.2 14.47 16 12 16s-4.52-1.8-4.93-4.15c-.08-.49-.49-.85-.98-.85-.61 0-1.09.54-1 1.14.49 3 2.89 5.35 5.91 5.78V20c0 .55.45 1 1 1s1-.45 1-1v-2.08c3.02-.43 5.42-2.78 5.91-5.78.1-.6-.39-1.14-1-1.14z" })
                    ], -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.micEnabled ? 'Mic on' : 'Mic off'), 1)
                  ], 10, _hoisted_3))
                : _createCommentVNode("", true),
              (!_ctx.audioOnly)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[14] || (_cache[14] = [
                    _createTextVNode("Choose ", -1),
                    _createElementVNode("strong", null, "Entire Screen", -1),
                    _createTextVNode(" in the picker so everything you do — other apps and tabs included — is captured.", -1)
                  ]))]))
                : _createCommentVNode("", true)
            ], 64))
          : (_ctx.state)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("span", {
                  class: _normalizeClass(["ai-rec-dot", { 'ai-rec-dot-paused': _ctx.paused }])
                }, null, 2),
                _createElementVNode("span", {
                  class: _normalizeClass(["ai-rec-time", { 'ai-rec-time-warn': _ctx.elapsedSec >= 1080 }])
                }, _toDisplayString(_ctx.paused ? 'Paused' : (_ctx.streaming ? 'Recording · ' : '') + _ctx.timeLabel), 3),
                (_ctx.micDenied)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, "no mic"))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: "ai-rec-discard",
                  title: _ctx.paused ? 'Resume recording' : 'Pause recording',
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.togglePause()))
                }, [
                  (!_ctx.paused)
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_8, [...(_cache[15] || (_cache[15] = [
                        _createElementVNode("path", { d: "M10 24h-6v-24h6v24zm10-24h-6v24h6v-24z" }, null, -1)
                      ]))]))
                    : (_openBlock(), _createElementBlock("svg", _hoisted_9, [...(_cache[16] || (_cache[16] = [
                        _createElementVNode("path", { d: "M3 22v-20l18 10-18 10z" }, null, -1)
                      ]))]))
                ], 8, _hoisted_7),
                _createElementVNode("div", {
                  class: "ai-rec-stop",
                  title: "Stop recording",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.stop()))
                }, [...(_cache[17] || (_cache[17] = [
                  _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "12",
                    height: "12",
                    viewBox: "0 0 24 24",
                    fill: "currentColor"
                  }, [
                    _createElementVNode("path", { d: "M4 4h16v16H4z" })
                  ], -1),
                  _createTextVNode(" Stop ", -1)
                ]))]),
                (!_ctx.streaming)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "ai-rec-discard",
                      title: "Discard recording",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.discardWhileRecording()))
                    }, [...(_cache[18] || (_cache[18] = [
                      _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "13",
                        height: "13",
                        viewBox: "0 0 24 24",
                        fill: "currentColor"
                      }, [
                        _createElementVNode("path", { d: "M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z" })
                      ], -1)
                    ]))]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
        (_ctx.canFloat && !_ctx.state && !_ctx.guard)
          ? (_openBlock(), _createElementBlock("label", _hoisted_10, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.autoFloat) = $event)),
                onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.saveAutoFloat && _ctx.saveAutoFloat(...args)))
              }, null, 544), [
                [_vModelCheckbox, _ctx.autoFloat]
              ]),
              _cache[19] || (_cache[19] = _createTextVNode("Float the controls automatically", -1))
            ]))
          : _createCommentVNode("", true),
        (_ctx.guard)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _cache[20] || (_cache[20] = _createElementVNode("strong", {
                id: "ai-rec-guard-title",
                class: "ai-rec-guard-title"
              }, "No call audio", -1)),
              _cache[21] || (_cache[21] = _createElementVNode("p", { id: "ai-rec-guard-text" }, "Only your microphone will be recorded. People on the call won’t be heard.", -1)),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("button", {
                  type: "button",
                  class: "ai-rec-guard-primary",
                  disabled: _ctx.guard.busy,
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.shareAgain && _ctx.shareAgain(...args)))
                }, _toDisplayString(_ctx.guard.busy ? 'Waiting for Chrome’s picker…' : 'Share again with sound'), 9, _hoisted_13),
                _createElementVNode("button", {
                  type: "button",
                  class: "ai-rec-guard-secondary",
                  disabled: _ctx.guard.busy,
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.continueWithoutAudio && _ctx.continueWithoutAudio(...args)))
                }, "Continue — we’re all in the room", 8, _hoisted_14)
              ]),
              (_ctx.guard.busy || _ctx.guard.attempts >= 2)
                ? (_openBlock(), _createBlock(_component_AiShareGuide, {
                    key: 0,
                    class: "ai-rec-guide-body",
                    note: _ctx.guard.attempts >= 2 ? 'Chrome shows the toggle under the screen preview.' : ''
                  }, null, 8, ["note"]))
                : _createCommentVNode("", true)
            ]))
          : (_ctx.streaming && !_ctx.audioOnly && !_ctx.state)
            ? (_openBlock(), _createElementBlock("details", _hoisted_15, [
                _cache[22] || (_cache[22] = _createElementVNode("summary", null, "How to include people on the call", -1)),
                _createVNode(_component_AiShareGuide, { class: "ai-rec-guide-body" })
              ]))
            : _createCommentVNode("", true),
        (_ctx.streaming && !_ctx.audioOnly)
          ? (_openBlock(), _createElementBlock("button", {
              key: 5,
              type: "button",
              class: "ai-rec-coach-link",
              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.openCoachHelp && _ctx.openCoachHelp(...args)))
            }, "How do I include call audio?"))
          : _createCommentVNode("", true),
        (_ctx.coach)
          ? (_openBlock(), _createBlock(_component_AiShareCoach, {
              key: 6,
              mode: _ctx.coach,
              onConfirm: _ctx.confirmCoach,
              onClose: _ctx.closeCoach
            }, null, 8, ["mode", "onConfirm", "onClose"]))
          : _createCommentVNode("", true),
        _createVNode(_component_AiFloatingRecorder, {
          ref: "floating",
          recording: !!_ctx.state,
          "call-audio": _ctx.streaming && !_ctx.audioOnly,
          guard: _ctx.guard,
          onShareAgain: _ctx.shareAgain,
          onContinue: _ctx.continueWithoutAudio,
          "display-stream": _ctx.displayStream,
          paused: _ctx.paused,
          "time-label": _ctx.timeLabel,
          "has-mic-audio": _ctx.hasMicAudio,
          "has-shared-audio": _ctx.hasSharedAudio,
          "mic-level": _ctx.micLevel,
          onPause: _ctx.togglePause,
          onStop: _ctx.stop
        }, null, 8, ["recording", "call-audio", "guard", "onShareAgain", "onContinue", "display-stream", "paused", "time-label", "has-mic-audio", "has-shared-audio", "mic-level", "onPause", "onStop"]),
        (_ctx.streaming && _ctx.state)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("span", null, _toDisplayString(_ctx.hasMicAudio ? 'Microphone on' : 'Microphone not included'), 1),
              (_ctx.hasMicAudio)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "ai-rec-level",
                    role: "meter",
                    "aria-label": "Microphone input level",
                    "aria-valuenow": Math.round(_ctx.micLevel * 100),
                    "aria-valuemin": "0",
                    "aria-valuemax": "100"
                  }, [
                    _createElementVNode("span", {
                      style: _normalizeStyle({ width: Math.round(_ctx.micLevel * 100) + '%' })
                    }, null, 4)
                  ], 8, _hoisted_17))
                : _createCommentVNode("", true),
              _createElementVNode("span", null, _toDisplayString(_ctx.hasSharedAudio ? 'Computer audio included' : 'Computer audio not shared'), 1),
              (!_ctx.hasSharedAudio)
                ? (_openBlock(), _createElementBlock("p", _hoisted_18, [
                    _createTextVNode(_toDisplayString(_ctx.hasMicAudio ? 'Your voice is included, but people on the call won’t be in the recording.' : 'Your microphone is not included, and people on the call won’t be in the recording.') + " Next time, choose ", 1),
                    _cache[23] || (_cache[23] = _createElementVNode("strong", null, "Entire Screen", -1)),
                    _cache[24] || (_cache[24] = _createTextVNode(" and turn on ", -1)),
                    _cache[25] || (_cache[25] = _createElementVNode("strong", null, "Share with system audio", -1)),
                    _cache[26] || (_cache[26] = _createTextVNode(" in Chrome’s picker. A single window never shares sound. On Mac, Chrome may also need Screen & System Audio Recording permission.", -1))
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("p", _hoisted_19, "Screen recording requires a desktop browser. Open this meeting in Chrome or Edge on your computer."))
}